export const idccAutoriseTT = Object.freeze(['1413', '2378'])
export const nafAutoriseTT = '7820Z' as const
export const idccBudgetBloque: readonly string[] = Object.freeze([])
